// BrowserRouter needs the deployment prefix, not the parent directory of the
// current URL. Deriving it with `lastIndexOf('/')` happened to work for every
// one-segment route, but treated `/SystemAdministration` as the basename when
// a nested system-administration URL was loaded directly. React Router then
// saw only `/AzureCosts`, so a refresh could not match the real route.
//
// Keep this list aligned with App's top-level routes. It lets the same build be
// hosted either at the origin root or below a configured deployment prefix.
const applicationRouteSegments = new Set([
  'AcceptInvitation',
  'AiReviewReplay',
  'AssessmentManagement',
  'AssessmentPublicationReplay',
  'ClientRequests',
  'ConsultantManagement',
  'CreateAccount',
  'CreatedOrganization',
  'EmployeeManagement',
  'EmployeeInvitation',
  'EmployeePortal',
  'FinalizedLifecycleReplay',
  'GroupManagement',
  'Help',
  'Login',
  'OngoingAssessmentReplay',
  'Onboarding',
  'OnboardingReplay',
  'OrganizationSettings',
  'ProducerPortal',
  'PositionManagement',
  'ProficiencyGroupManagement',
  'ProficiencyManagement',
  'RoleTemplateReplay',
  'SetupInvitation',
  'Start',
  'SubscriptionPage',
  'SyntheticTemplateReplay',
  'SystemAdministration',
  'TalentManagement',
  'TemplateManagement',
].map(segment => segment.toLowerCase()));

export const getRouterBasename = (pathname: string): string => {
  const pathSegments = pathname.split('/').filter(Boolean);
  const routeSegmentIndex = pathSegments.findIndex(segment => applicationRouteSegments.has(segment.toLowerCase()));

  if (routeSegmentIndex >= 0) {
    return routeSegmentIndex === 0 ? '' : `/${pathSegments.slice(0, routeSegmentIndex).join('/')}`;
  }

  return pathname.substring(0, pathname.lastIndexOf('/'));
};
